import React, { createContext, useState, useEffect } from 'react';

export const AppContext = createContext();

const isValidCarParkInfo = (carParkInfo) => {
  return carParkInfo && carParkInfo.guid && carParkInfo.carParkCode;
};

// const getInitialLang = () => {
//   const preferredLangs = Intl.DateTimeFormat().resolvedOptions().locale || 
//                          navigator.languages || 
//                          [navigator.language || navigator.userLanguage || 'en'];

//   const lang = (Array.isArray(preferredLangs) ? preferredLangs[0] : preferredLangs) || 'en';

//   if (lang.startsWith('en')) return 'en';
//   if (lang.includes('TW') || lang.includes('Hant') || lang.includes('zh-TW')) return 'zh-tw';
//   if (lang.includes('CN') || lang.includes('Hans') || lang.includes('zh-CN') || lang === 'zh') return 'zh-cn';
//   return 'en';
// };

// 強制預設語言為 'zh-cn'（簡體中文）
const DEFAULT_LANGUAGE = 'zh-cn';

// 取得初始語言：優先用 localStorage 記住嘅語言，如果無先用預設 'zh-cn'
const getInitialLang = () => {
  const savedLang = localStorage.getItem('appLanguage');
  if (savedLang && ['zh-tw', 'zh-cn', 'en'].includes(savedLang)) {
    return savedLang;
  }
  return DEFAULT_LANGUAGE; // 永遠 fallback 到簡體中文
};


const localStorageCarParkInfo = JSON.parse(localStorage.getItem('carParkInfo') || '{}');
const initialCarParkInfo = isValidCarParkInfo(localStorageCarParkInfo) ? localStorageCarParkInfo : null;
const detectedLang = getInitialLang();

export const AppProvider = ({ children, navigate }) => {
  const [carParkInfo, setCarParkInfo] = useState(initialCarParkInfo);
  const [currentLang, setCurrentLang] = useState(detectedLang);

  const updateCarParkInfo = (carParkInfo) => {
    if (isValidCarParkInfo(carParkInfo)) {
      localStorage.setItem('carParkInfo', JSON.stringify(carParkInfo));
      setCarParkInfo(carParkInfo);
    } else {
      localStorage.removeItem('carParkInfo');
      setCarParkInfo(null);
    }
  };

  // 監聽其他 tab/window 改 localStorage
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key !== 'carParkInfo') return;

      if (e.newValue === null) {
        setCarParkInfo(null);
        navigate && navigate('/');
      } else {
        try {
          const newCarParkInfo = JSON.parse(e.newValue);
          if (isValidCarParkInfo(newCarParkInfo)) {
            setCarParkInfo(newCarParkInfo);
            navigate && navigate('/');
          } else {
            setCarParkInfo(null);
            navigate && navigate('/');
          }
        } catch (error) {
          setCarParkInfo(null);
          navigate && navigate('/');
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [navigate]);

  const clearUserData = () => {
    updateCarParkInfo(null);
  };

  return (
    <AppContext.Provider
      value={{
        isLoggedIn: !!carParkInfo,
        carParkInfo,
        updateCarParkInfo,
        currentLang,
        setCurrentLang,
        clearUserData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};